import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import AreaMeasurement_001 from './img/AreaMeasurement_001.jpg'
import AreaMeasurement_002 from './img/AreaMeasurement_002.jpg'

export default class AreaMeasurement extends Component {
  render() {
    return (
      <div className="main-window">
        <div className="main-window-title">使用面积量测功能</div>
        <div className="main-window-content">1、点击面积量测</div>
        <div className="main-window-content">2、在球上点选，形成区域，面积数值实时展示</div>
        <img src={AreaMeasurement_001} className="main-window-img"></img>
        <img src={AreaMeasurement_002} className="main-window-img"></img>
      </div>
    )
  }
}
